import { trackPromise } from 'react-promise-tracker'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const updateUserPassword = async (token, accountId, supervisorID, oldPassword, newPassword) => {
  const body = {
    oldPassword: oldPassword,
    newPassword: newPassword
  }

  const options = {
    method: 'PUT',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(body)
  }

  const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/password`, options))
  if (!response.status || response.status !== 200) {
    return false
  } else {
    return true
  }
}

export const adminUpdateUserPassword = async (token, accountId, supervisorID, adminSupervisorID, oldPassword, newPassword) => {
  const body = { oldPassword, newPassword, adminSupervisorID }

  const options = {
    method: 'PUT',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(body)
  }

  const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/password`, options))
  if (response.status === 500 || !response.status || response.status === 403 || response.status === 401 ||
    response.status === 400 || response.status === 404) {
    return false
  } else {
    return true
  }
}
